export default __webpack_public_path__ + "static/media/cog-dark.f62b8d68.svg";